interface EditDialogProps {
  message: string;
  editStr: string;
  setEditStr: React.Dispatch<React.SetStateAction<string>>;
  onCancel: () => void;
  onOk: () => void;
}

export const EditDialog: React.FC<EditDialogProps> = ({
  message,
  editStr,
  setEditStr,
  onCancel,
  onOk,
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75">
      <div className="bg-white w-3/4">
        <div className="block">
          <h2 className="flex items-center justify-center mt-4 mx-4">
            {message}
          </h2>
          <input
            type="text"
            className="block appearance-none bg-white text-black border border-sub-blue rounded w-11/12 mt-4 p-2 mx-auto leading-5 focus:outline-none"
            defaultValue={editStr}
            onChange={(e) => setEditStr(e.target.value)}
          />
          <div className="mt-6">
            <button
              onClick={onCancel}
              className="inline-block border-t border-r border-black text-main-red w-1/2 py-3"
            >
              Cancel
            </button>
            <button
              className="inline-block border-t border-black text-sub-blue w-1/2 py-3"
              onClick={onOk}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
